(function () {
    'use strict';

    angular
        .module('app')
        .factory('auth', auth);

    auth.$inject = ['API', 'global', '$q', '$state', '$window', '$rootScope', '$timeout',];

    function auth(API, global, $q, $state, $window, $rootScope, $timeout) {
        var loggedIn = false;
        var service = {

            isLoggedIn: isLoggedIn,
            login: login,
            logout: logout,
        };

        activate();

        function activate() {
            var user = $window.localStorage.getItem('user');
            if (user) {
                user = JSON.parse(user);
            }

            if (user && user.userID && user.accessToken) {
                global.user = user;
                $timeout(function () {
                    $rootScope.$emit('login');
                }, 100);
                loadUser(user.userID, user.accessToken);
            }
        }

        return service;

        // Define public variables and methods

        function isLoggedIn() {
            if (loggedIn) {
                return true;
            }

            if ($window.localStorage.getItem('user')) {
                var user = $window.localStorage.getItem('user');
                if (user) {
                    loggedIn = true;
                    return true;
                }
            }

            return false;
        }

        function login(username, password) {
            return $q(function (resolve, reject) {
                API.User.login({ username: username, password: password, }).$promise.then(function (response) {
                    if (response && response.userID) {
                        global.user = response;
                        $window.localStorage.setItem('user', JSON.stringify(response));
                        loggedIn = true;
                        $timeout(function () {
                            $rootScope.$emit('login');
                        }, 100);
                        resolve(response);
                    } else {
                        loggedIn = false;
                        reject(responseToErrorCode(response));
                    }
                }, function (response) {
                    loggedIn = false;
                    reject(responseToErrorCode(response));
                });
            });
        }

        function logout() {
            loggedIn = false;
            global.user = null;
            $window.localStorage.removeItem('user');
            $timeout(function () {
                $rootScope.$emit('logout');
            }, 100);
            $state.go('login');
        }

        function loadUser() {
            API.User.get({ id: global.user.userID }).$promise.then(function (response) {
                if (response && response.id) {
                    var formattedUser = {
                        userID: response.id,
                        accessToken: response.access_token,
                        firstName: response.first_name,
                        lastName: response.last_name
                    };
                    global.user = formattedUser;
                    $window.localStorage.setItem('user', JSON.stringify(formattedUser));
                    loggedIn = true;
                } else {
                    loggedIn = false;
                }
            }, function () {
                loggedIn = false;
            });
        }

        function responseToErrorCode(response) {
            var error = 'error';
            if (response.status) {
                if (response.status === 401) {
                    error = 'credentials';
                }
            }
            return error;
        }
    }

})();